// extracted by mini-css-extract-plugin
export default {"editor":"editor_editor__kG3tO","headlineButtonWrapper":"editor_headlineButtonWrapper__CKXmE","headlineButton":"editor_headlineButton__+Zd+B"};